import * as React from 'react';
import { st, classes } from './StripCard.st.css';
import { deprecationLog, wrap, unwrap } from '../../common/deprecationLog';
export class StripCard extends React.Component {
    constructor(props) {
        super(props);
        wrap('Card');
    }
    componentDidMount() {
        deprecationLog('StripCard', 'The current `Card` component API will be deprecated in a future version. Please use the `upgrade` prop in order to use the new API.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--card');
        unwrap('Card');
    }
    render() {
        const { media, info, roundMedia, sidePadding, className } = this.props;
        return (React.createElement("div", { className: st(classes.root, { roundMedia, sidePadding }, className), "data-hook": this.props['data-hook'] },
            media ? React.createElement("div", { className: classes.mediaContainer }, media) : null,
            info ? React.createElement("div", { className: classes.infoContainer }, info) : null));
    }
}
StripCard.displayName = 'StripCard';
StripCard.MIN_WIDTH = 700;
StripCard.defaultProps = {
    roundMedia: false,
    sidePadding: true,
};
//# sourceMappingURL=StripCard.js.map